import {Errors, KAError} from "@repo/logging";

import type {GetSubtitles_subtitles as GqlVideoCaption} from "./__graphql-types__/GetSubtitles.ts";
import type {VideoCaption} from "./types.ts";

/**
 * Helper function that maps a GraphQL Video Caption to the object expected by
 * our frontend code.
 */
export const mapGqlVideoCaption = (
    gqlSubtitles: Array<GqlVideoCaption>,
): ReadonlyArray<VideoCaption> => {
    return gqlSubtitles.map((item) => ({
        endTime: _invariant(item.endTime, "endTime"),
        startTime: _invariant(item.startTime, "startTime"),
        kaIsValid: _invariant(item.kaIsValid, "kaIsValid"),
        text: _invariant(item.text, "text"),
    }));
};

/**
 * _invariant marks a field as invariant for TypeScript and asserts that a field is
 * non-null otherwise, throws an error.
 */
const _invariant = <T>(
    field: T | null | undefined,
    fieldName: string,
    extraData?: any,
): T => {
    if (field == null) {
        throw new KAError(
            `Field is unexpectedly null when mapping GraphQL types: ${fieldName}`,
            Errors.Internal,
            {
                sentryData: {
                    contexts: {
                        Data: {
                            fieldName,
                            ...extraData,
                        },
                    },
                },
            },
        );
    }

    return field;
};
